import React from 'react';
import { Flex, Heading, Icon, Text, Box } from 'pounceV2';
import { WRITING_RULES_DOC_URL } from 'Source/constants';
import { Panel } from 'reactflow';
import { LinkButtonV3 } from 'Components/buttons/LinkButton';
import { useTheme } from '@mui/material';

const EditorErrorMessageV3: React.FC<
  React.PropsWithChildren<Partial<React.ComponentProps<typeof Panel>>>
> = ({ children, ...rest }) => {
  const {
    palette: { tokens },
  } = useTheme();
  return (
    <Panel position="top-center" style={{ margin: '0' }} {...rest}>
      <Flex align="center" direction="column" gap={6} mt={6}>
        <Box backgroundColor={tokens.background.semantic.suggest[4]} borderRadius="circle" p={4}>
          <Icon color={tokens.background.semantic.suggest.base} type="hexagon-xmark" />
        </Box>
        <Heading textAlign="center">Invalid YAML</Heading>
        <Text lineHeight="loose" style={{ textWrap: 'inherit', wordBreak: 'break-word' }}>
          {children}
        </Text>
        <LinkButtonV3 variant="ghost" external size="medium" to={WRITING_RULES_DOC_URL}>
          Panther Documentation <Icon ml={2} type="external-link" size="medium" />
        </LinkButtonV3>
      </Flex>
    </Panel>
  );
};

export default EditorErrorMessageV3;
